<div class="ml-20 mr-20 mt-36 mb-20">
    <div class="col-span-12">
        <div class="card p-4">
            <p-toolbar styleClass="mb-4">
                <div class="p-toolbar-group-start">
                    <span class="text-xl font-bold">Accesso Negato</span>
                </div>
            </p-toolbar>

            <div class="error-content">
                <p class="message">
                    Il tuo account non risulta abilitato all'utilizzo dell'applicazione.
                </p>
            </div>

        </div>
    </div>
</div>